import { render, staticRenderFns } from "./share-sms.vue?vue&type=template&id=19361dc2&"
import script from "./share-sms.js?vue&type=script&lang=js&"
export * from "./share-sms.js?vue&type=script&lang=js&"
import style0 from "./share-sms.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports